import * as THREE from 'three';

import Store from '../Store';


export default class Skybox {
  constructor() {
    // global store
    const { 
      scene
    } = Store.getState();

    // Load textures
    const loader = new THREE.CubeTextureLoader();
    const texture = loader.load([
      'https://static.mused.org/CosmicCoolCloudRight.jpg', 'https://static.mused.org/CosmicCoolCloudLeft.jpg',
      'https://static.mused.org/CosmicCoolCloudTop.jpg', 'https://static.mused.org/CosmicCoolCloudBottom.jpg',
      'https://static.mused.org/CosmicCoolCloudFront.jpg', 'https://static.mused.org/CosmicCoolCloudBack.jpg',
    ]);

    texture.colorSpace = THREE.LinearSRGBColorSpace;
    // Create and assign skybox material
    // scene.background = texture;
    // scene.background = new THREE.Color(0x222222); 
    scene.background = new THREE.Color(0xeee6d7);

    // fog
    const color = 0xeee6d7;  
    const near = 0.1;
    const far = 1700;

    // scene.fog = new THREE.FogExp2(color, 0.001);
    scene.fog = new THREE.Fog(color, near, far);


    // if needed for fog over skybox
    // // Add a background box for fog over skybox 
    // const boxGeo = new THREE.SphereGeometry(2100, 2100, 2100);
    // // Create material with inverted textures
    // const boxMat = new THREE.MeshBasicMaterial({
    //     color: 0x000000, 
    //     side: THREE.BackSide  // This makes the material only visible from the inside of the box
    // });
    // // Create the box mesh
    // const box = new THREE.Mesh(boxGeo, boxMat);
    // // Position the box at the center of the scene
    // box.position.set(0, 0, 0);
    // scene.add(box);


    // const intensity = 150;
    // const distance = 1200;
    // const angle = 0.1;
    // const penumbra = 0.6;
    // const decay = 1;
    // const light = new THREE.SpotLight( color, intensity, distance, angle, penumbra, decay);
    // light.position.set( 0, 1.5, 0 );
    // light.target.position.set( - 5, 0, 0 );
    // scene.add( light );
    // scene.add( light.target );

    // const spotLightHelper = new THREE.SpotLightHelper( light );
    // scene.add( spotLightHelper );


  }


}
